module.exports = __webpack_public_path__ + "components/blogs-header/static/header--huge@2x-411edfe8152fb6989462e15a9f7c9677.jpg";